module.exports = __webpack_public_path__ + "fonts/tenon-lightitalic.woff2";